import axios from '@/axios'
import { getMessageFromError } from '@/utils/functions'

export default {
  getBatchModalData: async (_, { url, payload, excludes }) => {
    try {
      // eslint-disable-next-line no-unused-vars
      const { id } = payload
      const batchId = payload.batchId ? eval(`\`${payload.batchId}\``) : null

      // remove unnecessary keys
      excludes.forEach(x => delete payload[x])

      const res = await axios.get(eval(`\`${url}\``), {
        params: {
          ...payload,
          batchId
        }
      })

      return {
        data: res.data.data,
        FilteredCount: res.data.filteredCount,
        total: res.data.totalCount
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  getBatches: async ({ commit }, payload) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.get('/batch', {
        params: payload
      })
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      commit('SET_STATE', {
        action: 'batches',
        data: res.data.data
      })
      commit('SET_STATE', {
        action: 'total',
        data: res.data.totalCount
      })
      commit('SET_STATE', {
        action: 'FilteredCount',
        data: res.data.filteredCount
      })
      return {
        data: res.data.data,
        FilteredCount: res.data.filteredCount,
        total: res.data.totalCount
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },
  insert: async ({ commit }, payload) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.post('/batch', payload)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },
  delete: async ({ commit }, id) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.delete(`/batch/${id}`)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },
  get: async ({ commit }, id) => {
    try {
      const res = await axios.get(`/batch/${id}`)
      commit('SET_STATE', {
        action: 'batch',
        data: res.data.batch
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({ message })
    }
  },
  update: async ({ commit }, { id, data }) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.put(`/batch/${id}`, data)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({ message })
    }
  },

  // update batch status
  updateStatus: async ({ commit }, { id, payload }) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.put(`/batch/${id}/update-status`, payload)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({ message })
    }
  },

  // update batch location
  updateBatchLocation: async (_, { id, locationId }) => {
    try {
      const res = await axios.put(`/batch/${id}/change-location`, { locationId })

      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({ message })
    }
  },

  // update batch status
  updateProductStatus: async ({ commit }, { id, status }) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.put(`/batch/${id}/update-status`, { status })
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },
  getBatchPlants: async ({ commit }, { id, data, list }) => {
    commit('SET_STATE', {
      action: `${list}-loading`,
      data: true
    })

    const { limit, page, order, search, plantStages } = data

    const url = id ? `/batch-plant/${id}/get-plants` : '/batch-plant'
    try {
      const res = await axios.get(url, {
        params: {
          limit,
          page,
          order,
          search,
          plantStage: plantStages
        }
      })
      commit('SET_STATE', {
        action: `${list}-loading`,
        data: false
      })
      commit('SET_STATE', {
        action: `${list}-plants`,
        data: res.data.data
      })
      commit('SET_STATE', {
        action: 'batchPlantGroupByName',
        data: res.data.batchPlantGroupByName
      })
      commit('SET_STATE', {
        action: `${list}-total`,
        data: res.data.totalCount
      })
      commit('SET_STATE', {
        action: `${list}-FilteredCount`,
        data: res.data.filteredCount
      })
      return {
        data: res.data.data,
        batchPlantGroupByName: res.data.batchPlantGroupByName,
        FilteredCount: res.data.filteredCount,
        total: res.data.totalCount
      }
    } catch (err) {
      commit('SET_STATE', {
        action: `${list}-loading`,
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  destroyBatchPlants: async ({ commit }, payload) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.put('/batch/destroy-batch-plant', payload)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // restore batch plants
  restoreBatchPlants: async ({ commit }, payload) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.put('/batch/restore-batch-plant', payload)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },
  getBatchOptions: async () => {
    try {
      const res = await axios.get('/batch', {
        params: {
          limit: 0,
          page: 1
        }
      })
      return {
        data: res.data.data.map(batch => ({
          ...batch,
          value: batch.id,
          label: `${batch.batch_number} - (${batch.batch_name})`
        })),
        message: res.data.message
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject(message)
    }
  },
  insertPlant: async ({ commit }, payload) => {
    commit('SET_STATE', {
      action: 'plant-loading',
      data: true
    })
    try {
      const res = await axios.post('/batch-plant', payload)
      commit('SET_STATE', {
        action: 'plant-loading',
        data: false
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'plant-loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },
  deleteBatchPlant: async ({ commit }, id) => {
    commit('SET_STATE', {
      action: 'plant-loading',
      data: true
    })
    try {
      const res = await axios.delete(`/batch-plant/${id}`)
      commit('SET_STATE', {
        action: 'plant-loading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'plant-loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },
  getPlantById: async ({ commit }, id) => {
    try {
      const res = await axios.get(`/batch-plant/${id}`)
      commit('SET_STATE', {
        action: 'plant-plant',
        data: res.data.batchPlant
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({ message })
    }
  },
  updatePlant: async ({ commit }, { id, data }) => {
    commit('SET_STATE', {
      action: 'plant-loading',
      data: true
    })
    try {
      const res = await axios.put(`/batch-plant/${id}`, data)
      commit('SET_STATE', {
        action: 'plant-loading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'plant-loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({ message })
    }
  },
  getBatchWeightSummaryLogs: async ({ commit }, { id, data }) => {
    commit('SET_STATE', {
      action: 'batchWeightSummary-loading',
      data: true
    })
    const { limit, page, order, search } = data

    try {
      const res = await axios.get(`/batch-weight-summary/${id}/list`, {
        params: {
          limit,
          page,
          order,
          search
        }
      })

      commit('SET_STATE', {
        action: 'batchWeightSummary-loading',
        data: false
      })
      commit('SET_STATE', {
        action: 'batchWeightSummaryLogs',
        data: res.data.data
      })
      commit('SET_STATE', {
        action: 'batchWeightSummary-total',
        data: res.data.totalCount
      })
      commit('SET_STATE', {
        action: 'batchWeightSummary-FilteredCount',
        data: res.data.filteredCount
      })
      return {
        data: res.data.data,
        FilteredCount: res.data.FilteredCount,
        total: res.data.totalCount
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'batchWeightSummary-loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({ message })
    }
  },
  getBatchWeightSummary: async (_, id) => {
    try {
      const res = await axios.get(`/batch-weight-summary/${id}`)
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({ message })
    }
  },
  getStrainList: async (_, id) => {
    try {
      const res = await axios.get(`/batch-weight-summary/${id}/get-strain-list`, {
        params: {
          limit: 0,
          page: 1
        }
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({ message })
    }
  },
  updateBatchWeightSummary: async (_, { id, data }) => {
    try {
      const res = await axios.put(`/batch-weight-summary/${id}`, data)
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({ message })
    }
  },
  updateBatchOfPlants: async (_, { id, data }) => {
    try {
      const res = await axios.put(`/batch-plant/${id}/bulk-batch-update`, data)
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({ message })
    }
  },
  deleteBatchWeighSummaryLogAsync: async ({ commit }, id) => {
    commit('SET_STATE', {
      action: 'batchWeightSummary-loading',
      data: true
    })
    try {
      const res = await axios.delete(`/batch-weight-summary/${id}`)
      commit('SET_STATE', {
        action: 'batchWeightSummary-loading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'batchWeightSummary-loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },
  updateBulkPlantStage: async ({ commit }, { id, data }) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.put(`/batch-plant/${id}/bulk-stage-update`, data)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },
  getAllPlantsForPrintLabel: async (_, id) => {
    try {
      const res = await axios.get(`/batch-plant/${id}/get-plants`, {
        params: {
          limit: 0,
          page: 1,
          plantStage: ['seedling', 'pre_veg', 'veg', 'flower', 'drying', 'dried', 'mother', 'male']
        }
      })

      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },
  getAllPlantsForLookUp: async (_, { id, action }) => {
    try {
      const res = await axios.get(`/batch-plant/${id}/get-plants`, {
        params: {
          limit: 0,
          page: 1,
          action,
          plantStage: ['seedling', 'pre_veg', 'veg', 'flower', 'drying', 'dried', 'mother', 'male']
        }
      })
      return {
        data: res.data.data.map(plant => ({
          ...plant,
          value: plant.id,
          label: `${plant.serialNumber} - (${plant.plant_name})`
        })),
        message: res.data.message
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },
  // get batch records -- new design
  getBatchRecords: async (_, payload) => {
    try {
      const res = await axios.get('/batch', {
        params: {
          ...payload
        }
      })

      return {
        data: res.data.data,
        FilteredCount: res.data.filteredCount,
        total: res.data.totalCount
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },
  // get batch grid wise records -- new design
  getBatchGridRecords: async (_, payload) => {
    try {
      const res = await axios.get('/batch/grid-batch-list', {
        params: {
          ...payload
        }
      })

      return {
        data: res.data.data,
        FilteredCount: res.data.filteredCount,
        total: res.data.totalCount
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },
  // destroy multiple plants
  destroyMultiplePlants: async (_, payload) => {
    try {
      const res = await axios.post('/batch-plant/destroy-batch-plants', payload)

      return {
        message: res.data.message
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // get batch plants by batch id -- ulternative batch view
  getPlantsByBatch: async (_, { id, payload }) => {
    try {
      const res = await axios.get(`/batch-plant/${id}/get-plants`, {
        params: {
          ...payload
        }
      })

      return {
        data: res.data.data,
        FilteredCount: res.data.filteredCount,
        total: res.data.totalCount
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },
  // get batch plants for change plant stages
  getPlantsForPlantsStages: async (_, { id, data }) => {
    const { plantStages, growthPhases } = data
    const url = id ? `/batch-plant/${id}/get-plants` : '/batch-plant'
    try {
      const res = await axios.get(url, {
        params: {
          ...data,
          plantStage: plantStages,
          growthPhase: growthPhases
        }
      })

      return {
        data: res.data.data,
        FilteredCount: res.data.filteredCount,
        total: res.data.totalCount
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },
  // get archieve batch plant list
  getAchieveBatchPlantList: async ({ commit }, { id, payload }) => {
    try {
      const res = await axios.get(`/batch-plant/${id}/archive-plants`, {
        params: {
          ...payload
        }
      })

      commit('SET_STATE', {
        action: 'archived-plant-plants',
        data: res.data.data
      })
      commit('SET_STATE', {
        action: 'archived-plant-total',
        data: res.data.totalCount
      })
      commit('SET_STATE', {
        action: 'archived-plant-FilteredCount',
        data: res.data.filteredCount
      })

      return {
        data: res.data.data,
        FilteredCount: res.data.filteredCount,
        total: res.data.totalCount
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({ message })
    }
  },
  // update plants growth phase
  updatePlantsGrowthPhase: async (_, payload) => {
    try {
      const res = await axios.put('/batch/growth-phase-change', payload)

      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({ message })
    }
  },

  // assign metrc plant list
  assignMetrcPlantTag: async (_, payload) => {
    try {
      const res = await axios.put('/batch/growth-phase-change', payload)

      return {
        message: res.data.message
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  }
}
